module.exports = __webpack_public_path__ + "img/MeOH_Structures.c25ce1e4.png";